import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoGmail = () => {
  return (
    <g>
      <path d="m14.398 1.6h-12.796a1.6042 1.6042 0 0 0 -1.602 1.6015v9.597a1.6068 1.6068 0 0 0 1.602 1.6015h12.796a1.6068 1.6068 0 0 0 1.602-1.6015v-9.597a1.6043 1.6043 0 0 0 -1.602-1.6015zm0 11.199h-1.597v-7.039l-4.801 3.0385-4.801-3.0385v7.039h-1.597v-9.5975h.957l5.441 3.359 5.441-3.359h.957z" />
    </g>
  );
};

export default withIcon(IconLogoGmail);
